// extracted by mini-css-extract-plugin
module.exports = {"carbonEquivalentsList":"CarbonEquivalents_carbonEquivalentsList__eatN3"};